<template>
  <transition name="cookie-law" appear>
    <div class="cookie-law" v-if="show" v-cloak>
      <div class="text" v-cloak><slot></slot></div>
      <div class="buttons">
        <a :href="link" class="link" v-html="linkText"></a>
        <a href="#" class="accept" @click.prevent="accept" v-html="button"></a>
      </div>
    </div>
  </transition>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'CookieLaw',
  props: {
    cookie: {type: String, default: 'cookie-law'},
    button: {type: String, default: 'Allow cookies'},
    link: {type: String, default: null},
    linkText: {type: String, default: 'Learn more'},
  },
  data () {
    return {
      accepted: false,
      delayElapsed: false
    }
  },
  computed: {
    show () { return !this.accepted && this.delayElapsed }
  },
  created () {
    this.accepted = Cookies.get(this.cookie) === 'true'
    setTimeout(() => this.delayElapsed = true, this.delay)
  },
  methods: {
    accept () {
      Cookies.set(this.cookie, 'true', {expires: 7})
      this.accepted = true
    }
  }
}
</script>


// WEBPACK FOOTER //
// assets/js/components/CookieLaw.vue